"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Door = exports["default"] = /*#__PURE__*/function (_Core) {
  function Door(props) {
    var _this;
    var doorControlsAcceptors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, _classCallCheck2["default"])(this, Door);
    _this = _callSuper(this, Door, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.services = props.services;
    _this.myServices = ["door"];
    _this.init(doorControlsAcceptors);
    return _this;
  }
  (0, _inherits2["default"])(Door, _Core);
  return (0, _createClass2["default"])(Door, [{
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var status_change, data, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _t = message.action;
              _context.next = _t === 'System.SDK.ServiceNotification.Response' ? 2 : _t === "System.PeripheralsManager.DoorSwitch.Notifications" ? 4 : _t === 'System.ServiceNotification' ? 5 : 8;
              break;
            case 2:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
              }
              return _context.abrupt("return");
            case 4:
              status_change = JSON.parse(message.data);
              this.trigger("doorStatusChange", status_change);
              return _context.abrupt("return");
            case 5:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              // Send our data
              data = JSON.parse(message.data);
              _context.next = 7;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 7:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context.abrupt("return");
            case 8:
              return _context.abrupt("continue", 9);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "getDoorState",
    value: function () {
      var _getDoorState = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this3 = this;
        var uuid, origin, timestamp, payload, _t3;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context3.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: "System.PeripheralsManager.DoorSwitch.GetState",
                params: "{}"
              }, uuid, origin, timestamp);
            case 1:
              payload = _context3.sent;
              _context3.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                _this3.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(msg) {
                    var decryptedData, jsonObject, _t2;
                    return _regenerator["default"].wrap(function (_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(msg.action === 'System.SDK.ServiceCall')) {
                            _context2.next = 4;
                            break;
                          }
                          _context2.prev = 1;
                          _context2.next = 2;
                          return _encryption["default"].decryptSymmetrically(_this3.services["dpm"], msg.data);
                        case 2:
                          decryptedData = _context2.sent;
                          jsonObject = JSON.parse(decryptedData);
                          if (jsonObject.command === 'System.PeripheralsManager.DoorSwitch.GetState.Response') {
                            resolve(jsonObject.params);
                          }
                          _context2.next = 4;
                          break;
                        case 3:
                          _context2.prev = 3;
                          _t2 = _context2["catch"](1);
                          reject(_t2); // Properly handle decryption and parsing errors
                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2, null, [[1, 3]]);
                  }));
                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](0);
              console.error("Error sending start card reader message:", _t3);
              throw _t3;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function getDoorState() {
        return _getDoorState.apply(this, arguments);
      }
      return getDoorState;
    }()
  }, {
    key: "init",
    value: function init(doorControlsAcceptors) {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Door");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Print");
      } else {
        this.ready = true;
        this.trigger("ready", true);
        this.connection.on("messaging", this.handleMessage.bind(this));
      }
      this.connection.on("messaging", this.handleMessage.bind(this));
      this.connection.invoke('messaging', {
        uuid: (0, _uuid.v4)(),
        action: 'System.PeripheralsManager.DoorAcceptorsControl',
        timestamp: Number(BigInt(Date.now()) * 1000000n),
        origin: 'sdk-' + this.appName,
        doorControlsAcceptors: JSON.stringify({
          doorControlsAcceptors: doorControlsAcceptors
        })
      }).then(function () {
        _logger["default"].info("Initialization", "Sent initial door control message", "Door");
      })["catch"](function (error) {
        _logger["default"].error("Initialization", "Failed to send initial door control message", error);
      });
    }
  }]);
}(_core["default"]);